/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { AiOutlineWechat } from "react-icons/ai";
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';

// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import moment from 'moment';
import { BtnExportExcel, BtnSearch } from 'components/Common/Button';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import { AxiosGet, AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";


const InfoUVoiceReport = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [optionBA, setoptionBA] = useState([] as any);
    const [optionJobType, setoptionJobType] = useState([] as any);
    const [optionVOCType, setoptionVOCType] = useState([] as any);
    const [loadingTable, setloadingTable] = useState(false)

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dIssueDate",
        sSortDirection: "desc"
    });
    //#region  Form
    let objSchema = {
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        arrTypeJob: yupFormSchemas.stringArray("ประเภทใบงาน", { required: false }),
        arrTypeVOC: yupFormSchemas.stringArray("Type of VOC", { required: false }),
        arrDateIssue: yupFormSchemas.stringArray("วันที่แจ้ง", { required: true }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        let today = new Date();
        form.setValue("arrDateIssue", [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth(), today.getDate())])

        onGetOptionAll();
    }, [])

    const onGetOptionAll = async () => {
        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionBA(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrBA", arrValue)

                }
            })
        });
        await AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggest": true }, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionJobType(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrTypeJob", arrValue)
                }
            })
        });
        await AxiosGet(`MasterData/GetVOCFormType`, { "sLanguage": "th"}, (res) => {
            ResultAPI(res, null, () => {
                let arrOption = res.result?.data || []
                setoptionVOCType(arrOption)
                if (arrOption.length > 0) {
                    let arrValue = arrOption.map(item => item.value);
                    form.setValue("arrTypeVOC", arrValue)
                }
            })
        });

        await loadData();
    }


    const loadData = async (p: PaginationInterface = dataRow) => {
        BlockUI();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        let obj = {
            ...p,
            "arrBA": form.getValues("arrBA") || [],
            "arrTypeJob": form.getValues("arrTypeJob") || [],
            "arrTypeVOC": form.getValues("arrTypeVOC") || [],
            "sDateIssueStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("YYYY-MM-DD") + "" : null,
            "sDateIssueEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("YYYY-MM-DD") + "" : null,
            "isExport": false,
        }
        setloadingTable(true)
        await AxiosPost(`Report/SearchVOCReportStored`, obj, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                setloadingTable(false)
                setDataRow({
                    ...p,
                    arrRows: res.result.data || [],
                    nDataLength: res.result.nDataLength,
                    nPageIndex: res.result.nPageIndex,
                });
            })
        })
    };

    const ExportFile = (p: PaginationInterface = dataRow) => {
        let Param = {
            ...p,
            "arrBA": form.getValues("arrBA") || [],
            "arrTypeJob": form.getValues("arrTypeJob") || [],
            "arrTypeVOC": form.getValues("arrTypeVOC") || [],
            "sDateIssueStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("YYYY-MM-DD") + "" : null,
            "sDateIssueEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("YYYY-MM-DD") + "" : null,
            "isExport": true,
        }
        let sFileName = `ข้อมูล uVoice_${moment().format("DDMMYYYYHHmmss")}`;
        AxiosPostFileExcel(`ExportReport/ExportVOCReport`, Param, sFileName, null, null, BlockUI, UnBlockUI)
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sVOCFormCode",
            headerName: "เลขที่ใบแจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "dIssueDate",
            headerName: "วันที่แจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sCompanyName",
            headerName: "บริษัท",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
        },
        {
            field: "sAddress",
            headerName: "ที่อยู่/สถานที่เกิดเหตุ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 220,
            sortable: true,
        },
        {
            field: "sCustomerName",
            headerName: "ลูกค้า",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sBA",
            headerName: "กลุ่มตลาด",
            headerAlign: "center",
            flex: 1.5,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sTypeVOC",
            headerName: "ประเภทใบแจ้ง",
            headerAlign: "center",
            flex: 1.5,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sJobCode",
            headerName: "เลขที่ใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sTypeJob",
            headerName: "ประเภทใบงาน",
            headerAlign: "center",
            flex: 1.5,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sUnitRespon",
            headerName: "หน่วยงานที่รับผิดชอบ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sEmpRespon",
            headerName: "ผู้รับผิดชอบ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sCreate",
            headerName: "ผู้เปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "dCreate",
            headerName: "วันที่เปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sDiffCreate",
            headerName: "ระยะเวลาเปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "dResolved",
            headerName: "วันที่แก้ไขแล้วเสร็จ",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sDiffResolved",
            headerName: "ระยะเวลาการแก้ไข",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "dClosed",
            headerName: "วันที่ปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sScore",
            headerName: "คะแนน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sType",
            headerName: "ประเภท",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sTypeOfVOC",
            headerName: "Type of VOC",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sTypeOfVOCService",
            headerName: "Type of Service",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sComplaintIssueType",
            headerName: "ประเภทสำหรับการแก้ไข",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sComplaintIssueSubType",
            headerName: "ประเภทข้อร้องเรียนที่มีนัยสำคัญ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sGBUComplaintType",
            headerName: "GBU Compliant Type",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sRequestType",
            headerName: "ประเภทข้อร้องขอ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sContact",
            headerName: "ช่องทางการติดต่อ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
        },
        {
            field: "sDetailIssue",
            headerName: "รายละเอียดที่แจ้ง",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 250,
            sortable: true,
        },
        {
            field: "sProductService",
            headerName: "ผลิตภัณฑ์และบริการที่สนใจ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
        },
        {
            field: "sDetailResolved",
            headerName: "รายละเอียดการแก้ไข/ดำเนินตามคำร้อง",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 250,
            sortable: true,
        },
    ];

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<QueryStatsRoundedIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="รายงาน"
                label_nameRoute="ข้อมูล uVoice"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    {/* Search */}
                    <FormProvider {...form}>
                        <div className='div-border'>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start">
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={optionBA}
                                        label={'กลุ่มตลาด'}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrTypeVOC"
                                        options={optionVOCType}
                                        label={'ประเภทใบแจ้ง'}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} xl={2.5}>
                                    <MultiSelectForm
                                        name="arrTypeJob"
                                        options={optionJobType}
                                        label={'ประเภทคำร้อง'}
                                        required={false}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} xl={4.5}>
                                    <DateRangePicker
                                        label={"วันที่แจ้ง (เริ่มต้น)"}
                                        lableEnd={"วันที่แจ้ง (สิ้นสุด)"}
                                        require={true}
                                        name="arrDateIssue"
                                        maxDate={moment()}
                                    />
                                </Grid>
                                <Grid item xs={12} md={'auto'}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnSearch onClick={form.handleSubmit(() => { loadData() })} />
                                        </Grid>
                                        <Grid item>
                                            <BtnExportExcel onClick={() => { ExportFile() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </FormProvider>
                </Grid>
                <Grid item xs={12}>
                <div className='div-border'>
                    <Table
                        isLoading={loadingTable}
                        OnLoadData={(p) => loadData(p)}
                        Rows={dataRow}
                        HiddenToolHead={true}
                        Columns={dataColumn}
                        backgroundHeaderCustom={"#004290"}
                        sxCustomHeader={{ color: '#ffffff' }}
                        initialState={{
                            pinnedColumns: { left: ['nRow','sVOCFormCode','dIssueDate','sCompanyName']}
                        }}
                    />

                </div>

                    
                </Grid>
            </Grid>
        </>
    )
}

export default InfoUVoiceReport